// 获取cookie、
export function getCookie(name) {
  // eslint-disable-next-line one-var
  var arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  // eslint-disable-next-line no-cond-assign
  if (arr = document.cookie.match(reg)) { return (arr[2]) } else { return null }
}

// 设置cookie,增加到vue实例方便全局调用 单位小时
export function setCookie(cName, value, expireTime) {
  var exdate = new Date()
  // exdate.setDate(exdate.getDate() + expiredays)
  exdate.setTime(exdate.getTime() + (expireTime + 8) * 60 * 60 * 1000)
  document.cookie = cName + '=' + escape(value) + ((expireTime == null) ? '' : ';expires=' + exdate.toGMTString())
}

// 删除cookie
export function delCookie(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() }
}

// 获取字符数
export function getStringLengthForChinese(val) {
  const str = val ? val.toString(val) : ''
  let result = 0
  for (let i = 0; i < str.length; i++) {
    const temp = str.charCodeAt(i)
    if ((temp > 0x0001 && temp <= 0x007e) || (temp >= 0xff60 && temp <= 0xff9f)) {
      result += 1
    } else {
      result += 2
    }
  }
  return result
}

// 中国手机号码
export const phoneRegExp = /^1[0-9]{10}$/
// 邮箱
export const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
// 身份证
export const idCardRegExp = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
// 手机号正则校验
export const checkPhone = (rule, value, callback) => {
  if (phoneRegExp.test(value)) {
    callback()
  } else {
    callback('请输入正确的手机号')
  }
}
// 邮箱正则校验
export const checkEmail = (rule, value, callback) => {
  if (emailRegExp.test(value)) {
    callback()
  } else {
    callback('请输入正确的邮箱')
  }
}
// 身份证校验
export const checkCardId = (rule, value, callback) => {
  if (idCardRegExp.test(value)) {
    callback()
  } else {
    callback('请输入正确身份证号')
  }
}



// WEBPACK FOOTER //
// ./src/util/util.js